import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { TextField } from 'seagull';
import styles from './OTPField.module.scss';
export default function OTPField(_0) {
    let { isLoading, error, helperText, onChange } = _0, props = _object_without_properties(_0, [
        "isLoading",
        "error",
        "helperText",
        "onChange"
    ]);
    const [otp, setOtp] = useState('');
    return /*#__PURE__*/ _jsx(TextField, _object_spread({
        collapseHelperText: false,
        className: styles.otpInput,
        type: "text",
        inputMode: "numeric",
        autoComplete: "one-time-code",
        label: "6-digit code",
        placeholder: "",
        value: otp,
        testId: "otp-input",
        inputProps: {
            maxLength: 6
        },
        onChange: async (e)=>{
            const sanitizedOTPValue = e.target.value.slice(0, 6).replace(/\D/g, '');
            setOtp(sanitizedOTPValue);
            onChange(sanitizedOTPValue, sanitizedOTPValue.length === 6);
        },
        error: error,
        helperText: helperText,
        disabled: isLoading
    }, props));
}
